(function () {
  'use strict';

  var GIF_MARKER = 'ACwAAA';

  function isPlaceholder(src) {
    return !src || src.indexOf('data:') === 0 || src.indexOf(GIF_MARKER) !== -1;
  }

  function prefetchImg(img) {
    img.loading = 'eager';
    var src = img.dataset.src || (isPlaceholder(img.src) ? null : img.src);
    if (src) {
      var pi = new Image();
      if (img.srcset) pi.srcset = img.srcset;
      pi.src = src;
    }
    if (img.dataset.src) { img.src = img.dataset.src; }
    if (img.dataset.srcset) { img.srcset = img.dataset.srcset; }
  }

  function prefetchAll(gallery) {
    gallery.querySelectorAll('img').forEach(prefetchImg);
  }

  function watchGallery(gallery) {
    // Intercept lazy-loading src swaps in real time as the theme's IntersectionObserver fires
    var attrObs = new MutationObserver(function (muts) {
      muts.forEach(function (mut) {
        if (mut.type === 'attributes') {
          var img = mut.target;
          if (!isPlaceholder(img.src)) {
            var pi = new Image();
            if (img.srcset) pi.srcset = img.srcset;
            pi.src = img.src;
          }
        }
      });
    });
    gallery.querySelectorAll('img').forEach(function (img) {
      attrObs.observe(img, { attributes: true, attributeFilter: ['src', 'srcset'] });
    });
    // Also eagerly prefetch any images that already have a real src at this moment
    setTimeout(function () { prefetchAll(gallery); }, 300);
    // Safety-net pass after theme lazy-loading has had more time to run
    setTimeout(function () { prefetchAll(gallery); }, 2500);
  }

  function attachObserver() {
    var modal = document.querySelector('.quickbuy-modal');
    if (!modal) return;
    var content = modal.querySelector('.cc-popup-content');
    if (!content) return;

    new MutationObserver(function () {
      // Short delay so the theme finishes inserting the initial DOM structure
      setTimeout(function () {
        var gallery = modal.querySelector('.product-column-left');
        if (gallery) { watchGallery(gallery); }
      }, 100);
    }).observe(content, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachObserver);
  } else {
    attachObserver();
  }
}());